<ng-container *sbPageAction>
  <ng-container *ngIf="permissionService.hasPermission(permissionService.Permission.planning_submit) && submitted < 0">
    <button (click)="submitPartialPlanningModal()" *ngIf="submissions.length>0"
            [disabled]="bookingEditorService?.loading"
            style="border-color: #7f5fbf; background-color: #7f5fbf; color: #ffffff" class="btn font-weight-bold ml-1">
      <sb-icon icon="planningSubmit"></sb-icon>
      {{translate.instant('lang.globals.submitPartialPlanning', {itemCount: submissions.length})}}
    </button>
    <button (click)="submitPlanningDateModal()" *ngIf="submitted < 0 && !bookingEditorService.readonly"
            [disabled]="bookingEditorService?.loading" class="btn btn-primary font-weight-bold ml-1">
      <sb-icon icon="planningSubmit"></sb-icon>
      {{'lang.globals.submitPlanningDate'|translate}}
    </button>
  </ng-container>
</ng-container>


<div class="row">
  <div class="col-12">
    <div
      [ngClass]="submitted >=0 ? 'yellow-border' : (bookingEditorService.readonly ? 'red-border' : 'green-border')"
      class="card card-border-top custom-scrollbar overflow-hidden">
      <sb-card-loading-spinner *ngIf="bookingEditorService.loading"></sb-card-loading-spinner>
      <div class="card-header no-border">
        <div>
          <ng-container *ngIf="!bookingEditorService.loading">
            <h3><span [innerHTML]="bookingTitle|truncate:60"></span></h3>
            <small>
              <sb-icon class="mr-2" icon="user"></sb-icon>
              {{planningData?.forCustomer?.name}} <span class="mx-2">| </span>
              <span
                [ngClass]="planningData?.submissions.length >0 ? 'yellow' : (bookingEditorService.readonly ? 'red' : 'green')">
              <sb-icon class="mr-1" *ngIf="planningData?.submissions.length >0" icon="starFilled"></sb-icon>
              <sb-icon class="mr-1" *ngIf="planningData?.submissions.length <0 && bookingEditorService.readonly"
                       icon="readOnly"></sb-icon>
              <sb-icon class="mr-1" *ngIf="planningData?.submissions.length <0 && !bookingEditorService.readonly"
                       icon="edit"></sb-icon>
                {{planningData?.submissions.length > 0 ? ('lang.bookingEditor.bookingStatus.readyForBooking' | translate) : (bookingEditorService.readonly ? ('lang.bookingEditor.bookingStatus.readOnly' | translate) : ('lang.bookingEditor.bookingStatus.edit' | translate))}}
            </span>
            </small>
          </ng-container>
        </div>
        <div class="header-more">
          <div class="d-flex justify-content-between align-items-center">
            <!--            <button (click)="showToast()">Show toast</button>-->
            <input (ngModelChange)="search($event, 'Campaigns')" [ngModel]="searchValues.campaignVal"
                   class="form-control mr-2" placeholder="{{'lang.globals.searchCampaigns' | translate}}"
                   style="width: 270px;"
                   type="text">
            <input (ngModelChange)="search($event, 'Commercials')" [ngModel]="searchValues.commercialVal"
                   class="form-control mr-2" placeholder="{{'lang.globals.searchCommercials' | translate}}"
                   style="width: 270px;"
                   type="text">
            <sb-local-date-range-input class="mr-2" [from]="from" [till]="till" [showSubmit]="true" [today]="null" [disabled]="bookingEditorService.loading"
                                       (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
            <!--
            <select (change)="onDateSelect($event)" [(ngModel)]="selectedYear" [disabled]="bookingEditorService.loading"
                    class="form-select mr-2" style="width: 150px;">
              <option *ngFor="let year of years">{{year}}</option>
            </select>
            <button
                [disabled]="!bookingEditorService.rawData"
                class="btn btn-primary mr-2"
                (click)="prerenderCalendar()"
              >
              Render
            </button>
            -->
            <button
              container="body"
              [disabled]="bookingEditorService.loading || scheduler?.schedulerInstance?.zoomLevel === maxZoomLevel"
              ngbTooltip="{{'lang.globals.zoomIn' | translate}}" placement="left" class="btn btn-default mr-2"
              (click)="scheduler.schedulerInstance.zoomIn()">
              <sb-icon icon="zoomIn"></sb-icon>
            </button>
            <button
              container="body"
              [disabled]="bookingEditorService.loading || scheduler?.schedulerInstance?.zoomLevel === minZoomLevel"
              ngbTooltip="{{'lang.globals.zoomOut' | translate}}" placement="left" class="btn btn-default mr-2"
              (click)="scheduler.schedulerInstance.zoomOut()">
              <sb-icon icon="zoomOut"></sb-icon>
            </button>
            <button (click)="scrollToToday()" class="btn btn-default"
                    ngbTooltip="{{'lang.globals.scrollToToday' | translate}}"
                    placement="left" container="body">
              <sb-icon icon="calendar"></sb-icon>
            </button>
          </div>
        </div>
      </div>
      <div [ngClass]="[showSideBar ? 'leftOpen' : 'leftClose no-pointer-events', initial ? 'buttonInitial' : '']"
           class="sidebar-container tableBg">
        <div class="d-flex align-items-center h-100">
          <sb-booking-editor-medium-selection *ngPermissions="[permissionService.Permission.medium_group_list]"
                                              [selectedCompany]="planningData?.forCustomer"
                                              class="overflow-hidden h-100"
                                              style="width: 610px; border-right: 1px solid #ddd;"></sb-booking-editor-medium-selection>
          <button #tooltip="ngbTooltip" (click)="showSidebarFn()" *ngPermissions="[permissionService.Permission.medium_group_list]"
                  [autoClose]="false" [ngClass]="showSideBar ? 'mx-2' : ''"
                  class="btn btn-default position-relative sidebarButton"
                  ngbTooltip="{{'lang.globals.openMotiveGroups' | translate}}"
                  placement="right" container="body"
                  style="pointer-events: visible; height: 100px; padding: 1rem 0.8rem; top: 120px" triggers="manual">

            <sb-icon class="icon-in-btn" *ngIf="showSideBar" icon="arrowLeftAlt"></sb-icon>
            <sb-icon class="icon-in-btn" *ngIf="!showSideBar" icon="arrowRightAlt"></sb-icon>
          </button>
        </div>
      </div>
      <div class="card-fit">
        <bry-scheduler
          #scheduler
          (onSchedulerEvents)="dispatchEvent($event)"
          [autoAdjustTimeAxis]="false"
          [barMargin]="barMargin"
          [cellEditFeature]="false"
          [cellMenuFeature]="cellMenu"
          [columns]="columns"
          [createEventOnDblClick]="true"
          [endDate]="endDate"
          [eventColor]="eventColor"
          [eventDragCreateFeature]="features.eventDragCreate"
          [eventDragFeature]="features.eventDrag"
          [eventEditFeature]="eventEdit"
          [eventMenuFeature]="eventContextMenuFeature"
          [eventRenderer]="eventRenderer"
          [eventResizeFeature]="features.eventResize"
          [eventStore]="this.bookingEditorService.eventStore"
          [eventStyle]="eventStyle"
          [eventTooltipFeature]="eventTooltip"
          [headerMenuFeature]="false"
          [horizontalEventSorterFn]="commercialSorter"
          [minHeight]="minHeight"
          [presets]="presets"
          [readOnly]="bookingEditorService.readonly"
          [resourceMargin]="10"
          [resourceStore]="bookingEditorService.resourceStore"
          [resourceTimeRangesFeature]="true"
          [rowHeight]="rowHeight"
          [scheduleMenuFeature]="false"
          [snap]="false"
          [startDate]="startDate"
          [timeAxisHeaderMenuFeature]="false"
          [timeRangesFeature]="timeRanges"
          [treeFeature]="true"
          [viewPreset]="viewPreset"
          [zoomKeepsOriginalTimespan]="true"
          emptyText="{{'lang.booking.noCluster'| translate}}"
        ></bry-scheduler>
      </div>
    </div>
  </div>
</div>
